import "./styles/style.scss";
import "./components/Navigation/navigation.css";
import { I18nextProvider } from "react-i18next";
import React from "react";

import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./redux/store";
import i18n from "./translation/i18n";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import "webrtc-adapter";
import "leaflet/dist/leaflet.css";

// Onest font is now loaded via Google Fonts in index.html
// require("typeface-poppins"); // Replaced with Onest

const applyInitialTheme = () => {
  if (typeof window === "undefined") return;

  const storedTheme = localStorage.getItem("theme");
  const prefersDark =
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-color-scheme: dark)").matches;

  const nextTheme =
    storedTheme === "dark" || storedTheme === "light"
      ? storedTheme
      : prefersDark
      ? "dark"
      : "light";

  document.documentElement.setAttribute("data-theme", nextTheme);
};

const { PUBLIC_URL } = process.env;
console.log(process.env);

applyInitialTheme();

const container = document.getElementById("ts_root");
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <I18nextProvider i18n={i18n}>
          <BrowserRouter basename={PUBLIC_URL}>
            <App />
          </BrowserRouter>
        </I18nextProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
